<template>
    <div>
        <loading-gdb :propObject="!!loading_id" text="Carregando..."></loading-gdb>
        <v-text-field v-model="search" placeholder="Pesquisar"></v-text-field>
        <small>{{ (containers|| []).length }} Containers</small>
        <div v-for="state, index in Array.from(new Set(computedContainers.map(m => m.State))).sort()" :key="index" class="my-1">
            <div v-for="container, index in computedContainers.filter(f => f.State == state)" :key="index" class="my-1">
                <v-card :color="state == 'exited'? '': ''">
                    <v-card-title class="text-overline">{{ container.Names.join(",") }}</v-card-title>
                    <v-card-subtitle>
                        <v-row class="my-1">
                            {{ container.State }} - {{ container.Status }}
                            <v-spacer></v-spacer>
                            {{container.Image}}
                        </v-row>
                        <v-spacer></v-spacer>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="4" md="3" v-for="porta, p in container.Ports" :key="p">
                                <small>
                                    <span title="IP">{{porta.IP}}: </span>
                                    <span title="porta Pública">{{porta.PublicPort||'-'}}</span>
                                    /
                                    <span title="Porta Privada">{{porta.PrivatePort||'-'}}</span>
                                </small>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-btn-small icon color="success"
                                @click.stop="start_container(container.Id)"
                                :disabled="state === 'running'"
                                :loading="loading_id == `start-container-${container.Id}`">
                                <v-icon>mdi-play</v-icon>
                            </v-btn-small>
                            <v-btn-small icon color="error"
                                @click.stop="stop_container(container.Id)"
                                :disabled="state === 'exited'"
                                :loading="loading_id == `stop-container-${container.Id}`">
                                <v-icon>mdi-stop</v-icon>
                            </v-btn-small>
                            <v-btn-small icon :title="container.Id">
                                <v-icon>mdi-identifier</v-icon>
                            </v-btn-small>
                            <v-btn-small icon :title="container.HostConfig?.NetworkMode">
                                <v-icon>mdi-router-network</v-icon>
                            </v-btn-small>
                            <v-btn-small icon v-for="volume, v in container.Mounts" :key="v"
                                :title="`${volume.Type} - ${volume.Name} - ${volume.Destination}`">
                                <v-icon>mdi-database</v-icon>
                            </v-btn-small>
                            <v-spacer></v-spacer>
                            <v-btn :title="container.Id" :color="state === 'running'? 'success':'error'">
                                {{state === 'running'? 'Executando':'Parado'}}
                            </v-btn>

                        </v-row>
                    </v-card-text>
                </v-card>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'DockerComponent',
    data: () => ({
        containers: [],
        loading_id: null,
        search: '',
    }),
    mounted(){
        this.list_containers()
    },
    methods: {
        async list_containers(){
            this.loading_id = 'get-containers'
            try{
                const response = await this.$store.dispatch('GetDockerContainers', { method: 'list', filters: this.filters})
                if ('message' in response.data){
                    alert(response.data['message'])
                } else {
                    this.containers = response.data
                }
            } catch {
                //
            }
            this.loading_id = null
        },
        async start_container(id){
            this.loading_id = `start-container-${id}`
            try {
                const response = await this.$store.dispatch('GetDockerContainers', { method: 'start', id })
                if (response.status == 200){
                    console.log(response)
                }
            } catch {
                //
            }
            this.loading_id = null
            this.list_containers()
        },
        async stop_container(id){
            const confirma = confirm(`Tem certeza que deseja parar o Container ${id}?`)
            if (!confirma) return
            this.loading_id = `stop-container-${id}`
            try{
                const response = await this.$store.dispatch('GetDockerContainers', { method: 'stop', id })
                if (response.status == 200){
                    console.log(response)
                }
            } catch {
                //
            }
            this.loading_id = null
            this.list_containers()
        }
    },
    computed: {
        computedContainers(){
            const containers = this.containers
            if(this.search){
                return containers
                    .filter(f => {
                        const names = f.Names.join('|')
                        const tem_name = names.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
                        const tem_state = f.State.toLowerCase().indexOf(this.search.toLowerCase()) !== -1

                        return tem_name || tem_state
                    }
                )
            }
            return containers
        }
    }
    
}
</script>